import React from 'react';
import DaysSupplyCalculator from './DaysSupplyCalculator.react';

export default class DaysSupplyInformation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showDaysSupplyCalculator: false,
        }
    }

    render() {
        let guest = this.props.guest
        let daysSupplyRemaining = guest.DaysSupplyRemaining != null ? guest.DaysSupplyRemaining : "-"
        let showDaysSupplyCalculator = !!this.state.showDaysSupplyCalculator

        return (
            <div>
                <div className='row'>
                    <div className='col-6'>
                        Days Supply Remaining
                </div>
                    <div className='col-6'>
                        <span
                            onClick={() => this.setState({ showDaysSupplyCalculator: !this.state.showDaysSupplyCalculator })}
                            style={{ cursor: 'pointer' }}>
                            {daysSupplyRemaining} (Calculate)
                        </span>
                    </div>
                </div>

                {showDaysSupplyCalculator &&
                    <DaysSupplyCalculator
                        guest={guest}
                        onClose={() => this.setState({ showDaysSupplyCalculator: false })}
                    />
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/DaysSupplyInformation.react.jsx